import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { FormBuilder, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CommonModule } from '@angular/common';
import { Status } from '../../../interfaces/status.interface';
import { ToStatusDescPipe } from '../../../pipes/to-status-desc.pipe';
import { insertIf } from '../../../utilities/array/insertIf';
import { RoleService } from '../../../services/role.service';

export interface ChangeStatusDialogData {
  accountId: number;
  currentRegistrationStatus: Status;
  newRegistrationStatus: Status;
  showReason: boolean;
  reasonRequired?: boolean;
  organisationName: string;
  organisationEmail?: string;
  title?: string;
}

export interface ChangeStatusDialogResult {
  reason?: string;
}

@Component({
  selector: 'si-change-status-dialog',
  standalone: true,
  imports: [MatDialogModule, MatIconModule, MatFormFieldModule, MatInputModule, ToStatusDescPipe, MatButtonModule, ReactiveFormsModule, MatCheckboxModule, CommonModule],
  templateUrl: './change-status-dialog.component.html',
  styleUrl: './change-status-dialog.component.scss',
})
export class ChangeStatusDialogComponent {
  dialogRef = inject(MatDialogRef<ChangeStatusDialogComponent>);
  data = inject<ChangeStatusDialogData>(MAT_DIALOG_DATA);
  fb = inject(FormBuilder);
  roleService = inject(RoleService);
  Status = Status;
  
  statusForm = this.fb.group({
    reason: new FormControl('', [...insertIf(this.data.reasonRequired, Validators.required)]),
  });

  get showInfoMessage() {
    const statuses = [Status.Approved, Status.Rejected, Status.Withdrawn, Status.Revoke];
    return statuses.includes(this.data.newRegistrationStatus);
  }

  async handleConfirm() {
    if (!this.statusForm.valid) return;

    const result: ChangeStatusDialogResult = {
      reason: this.statusForm.controls.reason.value,
    };

    this.dialogRef.close(result);
  }

  handleClose() {
    this.dialogRef.close();
  }
}
